
import { Component, Input, Output, EventEmitter, OnInit, signal, ViewChild, OnDestroy, Renderer2 } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Product } from '../products/interfaces/products.interface';
import { AuthService } from '../../../../core/service/auth.service';
import { ShopCartService } from '../../../../shared/components/shop-cart/service/shop-cart.service';
import { LoaderGeneralService } from '../../../../shared/components/loader-general/service/loader-general.service';
import { Router } from '@angular/router';
import { EstablishmentIsOpenService } from '../../../../core/service/estasblishment-is-open.service';
import { ModalViewProductService } from './service/modal-view-product.service';
import { ComplementsVariationsComponent } from './component/complements-variations/complements-variations.component';
import { Variation, Complement, ProductViewResponse } from './interface/view-product.interface';
import { LoaderGeneralComponent } from "../../../../shared/components/loader-general/loader-general.component";
import { ProductData } from '../list-products/interfaces/list-products-new.interface';
import { Subscription } from 'rxjs';
import { gsap } from 'gsap';
import { ImageViewProduct } from "./component/image-view-product/image-view-product.component";
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'establishment-main-modal-view-product',
  standalone: true,
  imports: [RouterModule, ComplementsVariationsComponent, LoaderGeneralComponent, ImageViewProduct, NgxSkeletonLoaderModule],
  templateUrl: './modal-view-product.component.html',
  styleUrl: './modal-view-product.component.css'
})

export class ModalViewProductComponent implements OnInit, OnDestroy {

  @Input() product!: Product | ProductData ;
  quantity: number = 0;
  total: number = 0;
  loadingLoader: boolean = false;
  quanityProduct: number = 0;
  @Output() close = new EventEmitter<void>();
  errorMessages: string = '';
  isLoggedIn: boolean = false;
  loading: boolean = false;
  isAddingToCart: boolean = false;
  isOpen = signal(false);
  isLoadingComplementsVariations: boolean = false;
  isLoadingProduct: boolean = true;

  // Propiedades para variaciones y complementos
  variations: Variation[] = [];
  complements: Complement[] = [];
  private subscriptions: Subscription = new Subscription();
  // Referencia al componente de complementos y variaciones
  @ViewChild(ComplementsVariationsComponent) complementsVariationsComponent!: ComplementsVariationsComponent;
  establishmentId: string = '';
  constructor(
    private authService: AuthService,
    private shopcartService: ShopCartService,
    private loaderService: LoaderGeneralService,
    private router: Router,
    private establishmentService: EstablishmentIsOpenService,
    private modalViewProductService: ModalViewProductService,
    private route: ActivatedRoute,
    private renderer: Renderer2
  ) {
    this.isLoggedIn = this.authService.isLoggedIn();
    this.authService.getCurrentUser().subscribe(user => {
      this.isLoggedIn = !!user
    });
    this.loaderService.loading$.subscribe(loading => {
      this.loading = loading;

    });
  }

  ngOnInit(): void {
    // Prevenir scroll del body cuando el modal se abre
    const body = this.renderer.selectRootElement('body', true);
    this.renderer.addClass(body, 'no-scroll');
// console.log('producto de no se donde',this.product);

    this.route.params.subscribe(params => {
      const id: string = params['id'];
      if (id) {
        this.establishmentId = id;
        this.product.pg_establishments_id = parseInt(id);
      }
    });

    // Inicializar la cantidad disponible desde el stock del producto
    this.quantity = parseInt(this.product.pd_quantity) || 0;

    // Inicializar la cantidad seleccionada y el producto
    if (this.product.quantity === undefined) {
      this.product.quantity = 0;
    }
    this.quanityProduct = this.product.quantity;

    // Inicializar el total basado en la cantidad seleccionada
    this.calculateTotal();

    if (this.product.isOpen == undefined || this.product.apertura == undefined || this.product.cierre == undefined) {
      this.isOpen.update(() => true);
    } else {
      this.isOpen.update(() => this.establishmentService.isEstablishmentOpen(
        this.product.apertura!,
        this.product.cierre!,
        this.product.isOpen!
      ));
    }


    // Obtener las variaciones y complementos del producto desde la API
    this.isLoadingComplementsVariations = true;
    this.isLoadingProduct = true;
    this.modalViewProductService.getProductById(this.product.pd_id).subscribe({
      next: (response: ProductViewResponse) => {
        if (response.status && response.data && response.data.length > 0) {
          // Asignar las variaciones y complementos del primer elemento de data
          const productData = response.data[0];
          this.variations = productData.variations || [];
          this.complements = productData.complements || [];
          // console.log('Variaciones cargadas:', this.variations);
          // console.log('Complementos cargados:', this.complements);
          // Recalcular el total después de cargar variaciones y complementos
          setTimeout(() => this.calculateTotal(), 100);
        }
        this.isLoadingComplementsVariations = false;
        this.isLoadingProduct = false;
      },
      error: (error) => {
        console.error('Error al obtener datos del producto:', error);
        this.isLoadingComplementsVariations = false;
        this.isLoadingProduct = false;
      }
    });
  }

  closeModal() {
    // Reiniciar la cantidad seleccionada al cerrar el modal
    this.quanityProduct = 0;
    if (this.product) {
      this.product.quantity = 0;
      this.total = 0;
    }
    this.errorMessages = '';

    // Quitar la clase no-scroll del body al cerrar el modal
    const body = this.renderer.selectRootElement('body', true);
    this.renderer.removeClass(body, 'no-scroll');

    this.close.emit();
  }

  incrementQuantity(btnPlus?: HTMLElement, qtyValue?: HTMLElement, qtyContainer?: HTMLElement) {
    // Solo incrementar si hay stock disponible
    if (this.quantity > 0) {
      if (this.product.quantity === undefined) {
        this.product.quantity = 0;
      }
      this.product.quantity++;
      this.quanityProduct++;
      this.quantity--;
      // Calcular el total incluyendo variaciones y complementos
      this.calculateTotal();

      this.animateQuantityChange(btnPlus, qtyValue, qtyContainer, 'up');
    }
  }

  decrementQuantity(btnMinus?: HTMLElement, qtyValue?: HTMLElement, qtyContainer?: HTMLElement) {
    // Evitar cantidades negativas
    if (this.product.quantity !== undefined && this.product.quantity > 0) {
      this.product.quantity--;
      this.quanityProduct--;
      this.quantity++;
      // Calcular el total incluyendo variaciones y complementos
      this.calculateTotal();

      this.animateQuantityChange(btnMinus, qtyValue, qtyContainer, 'down');
    }
  }


  private animateQuantityChange(
    btn?: HTMLElement,
    qtyValue?: HTMLElement,
    qtyContainer?: HTMLElement,
    direction: 'up' | 'down' = 'up'
  ) {
    if (!btn || !qtyValue || !qtyContainer) {
      return;
    }

    const tl = gsap.timeline({ defaults: { ease: 'power1.out' } });

    tl.to(btn, { scale: 0.92, duration: 0.12 })
      .to(btn, { scale: 1, duration: 0.12 })
      .fromTo(
        qtyValue,
        { scale: 1, y: 0 },
        { scale: 1.2, y: direction === 'up' ? -3 : 3, duration: 0.18 },
        '<'
      )
      .to(qtyValue, { scale: 1, y: 0, duration: 0.18 })
      .fromTo(
        qtyContainer,
        { backgroundColor: '#ffffff' },
        { backgroundColor: '#fff3cd', duration: 0.2 },
        '<'
      )
      .to(qtyContainer, { backgroundColor: '#ffffff', duration: 0.2 });
  }
  addToCart(product: Product | ProductData, addBtn?: HTMLElement) {
    // No permitir agregar productos con cantidad 0
    if (!product.quantity || product.quantity <= 0) {
      this.errorMessages = 'Debe seleccionar al menos 1 producto';
      return;
    }

    // Verificar si hay variaciones requeridas sin seleccionar
    const requiredVariations = this.variations.filter(v => v.isRequired === true);
    const selections = this.complementsVariationsComponent?.getSelections();

    if (requiredVariations.length > 0 && (!selections || !selections.selectedVariations)) {
      this.errorMessages = 'Debe seleccionar las opciones requeridas';
      return;
    }

    // Verificar que todas las variaciones requeridas tengan una opción seleccionada
    const missingRequired = requiredVariations.some(v =>
      !selections?.selectedVariations[v.variation_id]
    );

    if (missingRequired) {
      this.errorMessages = 'Debe seleccionar todas las opciones requeridas';
      return;
    }

    const productToAdd: Product | ProductData = {
      ...product,
      selectedVariations: selections?.selectedVariations,
      selectedComplements: selections?.selectedComplements
    } as Product;

    // Animación del botón Añadir antes de procesar el agregado
    if (addBtn) {
      const tl = gsap.timeline({ defaults: { ease: 'power1.out' } });
      tl.to(addBtn, { scale: 1.05, duration: 0.15 })
        .to(addBtn, { scale: 1, duration: 0.15 })
        .eventCallback('onComplete', () => {
          this.isAddingToCart = true;
          // console.log('se añade ', productToAdd);

          this.shopcartService.addNewProduct(productToAdd).subscribe({
            next: () => {
              this.isAddingToCart = false;
              this.closeModal();
            },
            error: (error: any) => {
              this.isAddingToCart = false;
              this.errorMessages = error.message;
            }
          });
        });
    } else {
      // Fallback si no hay referencia del botón
      this.isAddingToCart = true;
      // console.log('se añade ', productToAdd);
      this.shopcartService.addNewProduct(productToAdd).subscribe({
        next: () => {
          this.isAddingToCart = false;
          this.closeModal();
        },
        error: (error: any) => {
          this.isAddingToCart = false;
          this.errorMessages = error.message;
        }
      });
    }
  }

  // Método para navegar a la página de login
  navigateToLogin() {
    this.router.navigate(['/auth/login']);
    this.closeModal();
  }

  /**
   * Calcula el total del producto incluyendo variaciones y complementos
   */
  calculateTotal() {
    if (!this.product.quantity) {
      this.total = 0;
      this.product.subtotal = 0;
      return;
    }

    // Precio base del producto
    let basePrice = parseFloat(this.product.pd_unit_price.toString());

    // Obtener selecciones actuales
    const selections = this.complementsVariationsComponent?.getSelections();

    // Sumar ajustes de precio de variaciones seleccionadas
    if (selections?.selectedVariations && this.variations.length > 0) {
      Object.entries(selections.selectedVariations).forEach(([variationId, optionId]) => {
        // Convertir a string para asegurar la comparación correcta
        const variation = this.variations.find(v => v.variation_id.toString() === variationId.toString());
        if (variation) {
          // Convertir a string para asegurar la comparación correcta
          const selectedOption = variation.options.find(opt => opt.variationOption_id.toString() === optionId.toString());
          if (selectedOption && selectedOption.priceAdjustment) {
            const adjustment = parseFloat(selectedOption.priceAdjustment);
            basePrice += adjustment;
          }
        }
      });
    }

    // Sumar precios de complementos seleccionados
    if (selections?.selectedComplements && this.complements.length > 0) {
      selections.selectedComplements.forEach(complementId => {
        const complement = this.complements.find(c => c.PK_complement_id === complementId);
        if (complement && complement.price) {
          const complementPrice = parseFloat(complement.price);
          basePrice += complementPrice;
        }
      });
    }

    // Calcular total final
    this.product.subtotal = this.product.quantity * basePrice;
    this.total = this.product.subtotal;
  }

  // Add a method to navigate to login
  ngOnDestroy(): void {
    // Limpiar todas las suscripciones
    this.subscriptions.unsubscribe();

    // Quitar la clase no-scroll del body al destruir el componente
    const body = this.renderer.selectRootElement('body', true);
    this.renderer.removeClass(body, 'no-scroll');
  }
}
